export default __webpack_public_path__ + "static/media/bullhorn.203bb44a.svg";